import React from "react";
import { Container, Row, Col, Button } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import "bootstrap/dist/css/bootstrap.min.css";
import "./TransportHomeSection.css";
import europeMapImg from "../../assets/images/logotwo.jpg";
import { useNavigate } from "react-router-dom";

export default function TransportHomeSection() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const handleButtonClick = () => {
    navigate("/register/client");
  };

  const steps = [
    t("transportHomeNew.steps.step1"),
    t("transportHomeNew.steps.step2"),
    t("transportHomeNew.steps.step3"),
  ];

  return (
    <section className="transport-driver-section py-5">
      <Container>
        <Row className="align-items-center justify-content-center">
          <Col xs={12} md={6} lg={6} className="text-white mb-4 mb-md-0">
            <h2 className="fw-bold mb-3 transport-driver-title">
              {t("transportHomeNew.title")}
            </h2>
            <p className="transport-driver-subtitle">
              <span className="text-orange fw-bold">
                {t("transportHomeNew.subtitle")}
              </span>{" "}
              {t("transportHomeNew.subtitleContinue")}
            </p>
            
            <div className="how-it-works-section mb-4">
              <p className="fw-bold mb-3">{t("transportHomeNew.howItWorks")}</p>
              <ol className="steps-list">
                {steps.map((step, index) => (
                  <li key={index}>{step}</li>
                ))}
              </ol>
            </div>
            
            <p className="provider-note mb-4">
              <strong>{t("transportHomeNew.forProviders")}</strong>{" "}
              {t("transportHomeNew.forProvidersText")}
            </p>
            
            <Button
              className="fw-bold px-4 shadow-sm btn-orange btn-xl driver-register-btn"
              onClick={handleButtonClick}
            >
              {t("transportHomeNew.buttonText")}
            </Button>
          </Col>
          <Col md={6} data-aos="fade-left" className="text-center">
            <div className="europe-map-container">
              <img
                src={europeMapImg}
                alt="Europe Transport Map"
                className="img-fluid rounded shadow europe-map-img"
              />
            </div>
          </Col>
        </Row>
      </Container>
    </section>
  );
}
